import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const PlusSimpleShape = ({
  width = 40,
  height = 40,
  fillColor = '#000',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 8"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0_340_1988)">
      <path
        d="M4 6.33366V1.66699"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66669 4H6.33335"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_340_1988">
        <rect width="8" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PlusSimpleShape;
